import React from 'react';
import classNames from 'classnames';

import css from './IconSofa.module.css';

/**
 * IconSofa icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconSofa = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.99905 12V13H16.999V12C16.999 10.3454 18.3385 9.00368 19.9922 9.00001C19.9837 8.67199 19.9647 8.43379 19.9221 8.21964C19.6065 6.63288 18.3661 5.39249 16.7794 5.07686C16.393 5 15.9283 5 14.999 5H8.99905C8.06974 5 7.60508 5 7.21869 5.07686C5.63193 5.39249 4.39154 6.63288 4.07591 8.21964C4.03331 8.43379 4.01432 8.67199 4.00586 9.00001C5.65958 9.00368 6.99905 10.3454 6.99905 12Z" fill="#262338"/>
<path d="M18.4444 18H5.55556C5.27849 18 5.00883 17.9683 4.75 17.9084V19C4.75 19.4142 4.41421 19.75 4 19.75C3.58579 19.75 3.25 19.4142 3.25 19V17.1513C2.48508 16.4991 2 15.5284 2 14.4444V12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12V13.2C6 13.6418 6.35817 14 6.8 14H17.2C17.6418 14 18 13.6418 18 13.2V12C18 10.8954 18.8954 10 20 10C21.1046 10 22 10.8954 22 12V14.4444C22 15.5284 21.5149 16.4991 20.75 17.1513V19C20.75 19.4142 20.4142 19.75 20 19.75C19.5858 19.75 19.25 19.4142 19.25 19V17.9084C18.9912 17.9683 18.7215 18 18.4444 18Z" fill="#262338"/>
</svg>

  );
};

export default IconSofa;
